import { KnowledgeBaseConsts } from 'client/util/Constants';
import KnowledgeApi, { isValidSearchTerm } from 'api/v2/KnowledgeApi';
import Vue from 'vue';

const { kbFields } = KnowledgeBaseConsts;

const initialState = () => ({
  errorFetching: false,
  isFiltering: false,
  shouldClearResourcesAlert: false,
  knowledgeBaseItems: [],
  whatsNewItems: [],
});

export const createKnowledgeModule = () => ({
  namespaced: true,
  state: initialState(),
  actions: {
    fetchKnowledge({ dispatch }, { searchTerm }) {
      return new Promise((resolve, reject) => {
        dispatch('setErrorFetching', false);
        // if it's invalid, ignore it
        const validSearchTerm = isValidSearchTerm(searchTerm) ? searchTerm : '';
        const {
          articleTotalViewCount,
          id,
          body,
          publishedDate,
          title,
          url,
        } = kbFields;

        KnowledgeApi.fetch([id, body, publishedDate, title, url], {
          searchTerm: validSearchTerm,
          sort: `-${articleTotalViewCount}`,
        })
          .then((resp) => {
            dispatch('updateKnowledgeBaseItems', resp.results);
            dispatch('setIsFiltering', searchTerm !== undefined && searchTerm !== '');
            resolve();
          })
          .catch((err) => {
            dispatch('setErrorFetching', true);
            reject(err);
          });
      });
    },

    fetchWhatsNew({ dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('setErrorFetching', false);
        const {
          id,
          isWhatsNew,
          publishedDate,
          title,
          url,
          whatsNewBlurb,
          whatsNewTitle,
        } = kbFields;

        const fields = [
          id,
          title,
          publishedDate,
          url,
          whatsNewBlurb,
          whatsNewTitle,
        ];
        const customParams = {
          filter: [{
            name: isWhatsNew,
            operator: 'eq',
            value: true,
          }],
          sort: `-${publishedDate}`,
        };

        return KnowledgeApi.fetch(fields, customParams)
          .then((resp) => {
            dispatch('updateWhatsNewItems', resp.results);
            resolve();
          })
          .catch((err) => {
            dispatch('setErrorFetching', true);
            reject(err);
          });
      });
    },

    setAllUnreadToFalse({ commit, state }) {
      state.whatsNewItems.forEach((_, index) => {
        commit('SET_UNREAD_TO_FALSE', index);
      });
    },

    setErrorFetching({ commit }, errorFetching) {
      commit('SET_ERROR_FETCHING', errorFetching);
    },

    setIsFiltering({ commit }, isFiltering) {
      commit('SET_IS_FILTERING', isFiltering);
    },

    removeResourcesAlert({ commit }) {
      commit('CLEAR_RESOURCES_ALERT');
    },

    updateKnowledgeBaseItems({ commit }, payload) {
      commit('UPDATE_KNOWLEDGE_BASE_ITEMS', payload);
    },

    updateWhatsNewItems({ commit }, payload) {
      commit('UPDATE_WHATS_NEW_ITEMS', payload);
    },
  },
  getters: {
    unreadWhatsNewItemsCount(state) {
      return state.whatsNewItems.filter(item => item.unread).length;
    },
  },
  mutations: {
    CLEAR_RESOURCES_ALERT(state) {
      Vue.set(state, 'shouldClearResourcesAlert', true);
    },

    UPDATE_KNOWLEDGE_BASE_ITEMS(state, payload) {
      Vue.set(state, 'knowledgeBaseItems', payload);
    },

    UPDATE_WHATS_NEW_ITEMS(state, payload) {
      Vue.set(state, 'whatsNewItems', payload);
    },

    SET_ERROR_FETCHING(state, errorFetching) {
      Vue.set(state, 'errorFetching', errorFetching);
    },

    SET_IS_FILTERING(state, isFiltering) {
      Vue.set(state, 'isFiltering', isFiltering);
    },

    SET_UNREAD_TO_FALSE(state, index) {
      Vue.set(state.whatsNewItems[index], 'unread', false);
    },
  },
});

export default createKnowledgeModule();
